import React, {Fragment, useEffect, useState} from 'react';
// import SwipeableDialog from "react-swipeable-bottom-sheet";
import { closeIcon } from '../../styles/images/icons';
import { useBreakpoints } from '../../utils/customHooks/useBreakpoints';
import { Popup } from 'podro-design-system';
import { Col, Container, Row } from 'reactstrap';
import { Card } from 'podro-design-system/lib/components/Card/Card';
import { BottomSheet } from 'react-spring-bottom-sheet';
import "./dialog.scss";

const Body = (props) => {
    const { breakpoint, down } = useBreakpoints();
    const {
        openBottomSheet,
        changeBottomSheet,
        children,
        size,
        title,
        footer
    } = props;

    // const disableSwipe = true;
    // const nested = true;

    useEffect(() => {
        setTimeout(() => {
            if (breakpoint === 'xs') {
                var backdrop = document.querySelector('[data-rsbs-backdrop]');
                backdrop?.addEventListener('click', () => changeBottomSheet(false), false);
            }
        }, 100);
    }, [openBottomSheet]);
    
    return down('sm') ? (
        <>
            {/* <SwipeableBottomSheet
                // overflowHeight={0}
                open={openBottomSheet}
                style={{zIndex: '10000'}}
                onChange={(e) => changeBottomSheet(false)}
                bodyStyle={{
                    width: !nested && 'calc(100% - 40px)',
                    height: 'auto',
                    maxHeight: '85vh',
                    border: '1px solid #e0e0e0',
                    transform: !nested && 'translateX(20px)',
                    borderRadius: '10px 10px 0 0',
                    direction: "rtl"
                }}
                // overlayStyle={{}}
                topShadow={false}
                swipeableViewsProps={{ disabled: disableSwipe }}
                scrollTopAtClose={false}>
                    {/* <div className="card-container"> */}
                        {/* {children} */}
                    {/* </div> */}
            {/* </SwipeableBottomSheet> */}  
            <BottomSheet  open={openBottomSheet} onDismiss={() => changeBottomSheet(false)}
                className='bottom-sheet'
                header={
                    <div className="font-12 font-semi-bold d-flex align-items-center py-2">
                        {title}
                        <div className="fg-1" />
                        {props.actionButton}
                        {!props.disableClose && (
                            <div className="bottom-sheet-close-btn mr-3" onClick={() => changeBottomSheet(false)}>
                                {closeIcon}
                            </div>
                        )}
                    </div>
                }
                draggable={true}
                
                footer={footer}>
                    
                <div className="p-3 bottom-sheet-content-wrapper">
                    {children}
                </div>
            </BottomSheet>
        </>
    ) : openBottomSheet ? (
        <div className="scroll-popup">
            <Popup>
                <Container className="space-card">
                    <Row className="d-flex align-items-center justify-content-center" >
                        <Col sm={size}>
                            <Card className="card-container">
                                <div className="bottom-sheet-title-wrapper">
                                    <div className="font-12 font-semi-bold d-flex align-items-center p-3">
                                        {props.title}
                                        <div className="fg-1" />
                                        {props.actionButton}
                                        {!props.disableClose && (
                                            <div className="bottom-sheet-close-btn ml-3" onClick={() => changeBottomSheet(false)}>
                                                {closeIcon}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="p-3">
                                    {children}
                                </div>
                                
                                {footer && (
                                    <div className={`d-flex align-items-center justify-content-center px-3 pb-3`}>
                                        {footer}
                                    </div>
                                )}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Popup>
        </div>
    ) : null;
}

const Dialog = (props) => {

    // const disableSwipe = true;
    // const nested = true;

    // useEffect(() => {
    //     var scrollTopPostion = 0;

    //     if (props?.openBottomSheet) {
    //         scrollTopPostion = -1 * document.documentElement.scrollTop + 'px';
    //         // document.body.style.position = 'fixed';
    //         document.body.style.top = scrollTopPostion;
    //         document.body.classList.add('no-scroll');

    //     } else {
    //         document.body.style.top = scrollTopPostion;
    //         document.body.classList.remove('no-scroll');
    //     }
    // }, [props?.openBottomSheet]);

    // const { breakpoint } = useBreakpoints();

    return (
        <Body {...props}>
            {/* <div className={`p-3 ${props.fixBody && "bottom-sheet-fix-body"} ${props.noPadding && "bottom-sheet-no-padding"}`}> */}
                {props.children}
            {/* </div> */}
            {/* {props.button} */}
        </Body>
    );
};

export default Dialog;
